module.exports = __webpack_public_path__ + "static/media/2.37ad29a7.jpeg";